// @ts-nocheck
import { FormFieldStyle, FormInputWrapper } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import constants from "@store/constants";
// import { typographyTitleStyles } from "@store/Themes/common/mixins/typography"; // Store Custom Code
import breakpointValues, { BreakpointValue } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { Amount, pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import { typographyTitleStyles } from "@store/Themes/common/mixins/typography";
/* Store Custom Code - End */

const titleStyles = (fontSizes: BreakpointValue<Amount>[]) => css`
    ${typographyTitleStyles(pxToRemArray(fontSizes))}
    ${spacingStyles("1em", "0.4em") /* Store Custom Code */}
`;

const typography: Styleguide["typography"] = {
    fontFamilyImportUrl: `${constants.path.fonts}/common.css`, // Store Custom Code
    body: {
        size: "inherit",
        weight: "inherit",
        fontFamily: "inherit",
        css: css`
            color: ${getColor("text")};
            font-style: normal;
            text-transform: none;
            /* Store Custom Code - Start */
            letter-spacing: normal;
            -webkit-font-smoothing: antialiased;
            /* Store Custom Code - End */

            ${({ theme }) => `
                font-family: ${theme.design.typography.fontFamily.base};
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    p: {
        size: "inherit",
        weight: "inherit",
        css: spacingStyles(),
    },
    h1: {
        css: css`
            ${titleStyles([26, null, 42, null, 48]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            text-transform: uppercase; /* Store Custom Code */
            font-weight: ${x => x.theme.design.typography.weight.light /* Store Custom Code */};
        `,
    },
    h2: {
        css: css`
            ${titleStyles([22, null, 30, null, 36]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            font-weight: ${x => x.theme.design.typography.weight.light /* Store Custom Code */};
        `,
    },
    h3: {
        css: css`
            ${titleStyles([20, null, 24, null, 28]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            font-family: ${x => x.theme.design.typography.fontFamily.title /* Store Custom Code */};
        `,
    },
    h4: {
        css: css`
            ${titleStyles([18, null, 20]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            font-family: ${x => x.theme.design.typography.fontFamily.title /* Store Custom Code */};
        `,
    },
    h5: {
        css: css`
            ${titleStyles([16]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            font-family: ${x => x.theme.design.typography.fontFamily.title /* Store Custom Code */};
        `,
    },
    h6: {
        css: css`
            ${titleStyles([12]) /* Store Custom Code */}
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
            text-transform: uppercase; /* Store Custom Code */
            letter-spacing: ${pxToRem(1) /* Store Custom Code */};
            /* Store Custom Code - Start */
            & + h1,
            & + h2,
            & + h3,
            & + h4,
            & + h5,
            & + h6,
            & + .heading {
                margin-top: 0;
            }
            /* Store Custom Code - End */
        `,
    },
    legend: {
        size: "inherit",
        weight: "inherit",
        color: null as any,
        transform: null as any,
        css: css`
            color: ${getColor("text.main")};
            margin-bottom: ${pxToRem(1)};
            text-transform: none; /* Store Custom Code */

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.smaller /* Store Custom Code */};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.base};
            `};

            &&& + ${FormInputWrapper}, &&& + ${FormFieldStyle} {
                margin-top: ${pxToRem(2)};
            }
        `,
    },
    bannerText: {
        css: css`
            /* Store Custom Code - Start */
            font-size: ${x => x.theme.design.typography.size.base};
            margin-bottom: ${pxToRem(24)};
            line-height: 1.6;

            &:last-child {
                margin-bottom: 0;
            }
            /* Store Custom Code - End */
        `,
    },
    /* Store Custom Code - Start */
    bannerSmallText: {
        css: css`
            /* Store Custom Code - Start */
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-bottom: ${pxToRem(24)};
            line-height: 1.6;

            &:last-child {
                margin-bottom: 0;
            }
            /* Store Custom Code - End */
        `,
    },
    smallText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.smaller};
            margin-bottom: ${pxToRem(14)};
            line-height: 1.6;

            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
    /* Store Custom Code - End */
};

typography.bannerTitle = {
    ...typography.h1,
    forwardAs: "h1",
    css: css`
        ${typography.h1?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
        /* Store Custom Code - Start */
        margin-top: 0;
        /* Store Custom Code - End */
    `,
};

typography.bannerSecondaryTitle = {
    ...typography.h2,
    forwardAs: "h1",
    css: css`
        ${typography.h2?.css}
        ${breakpointValues(pxToRemArray([16, null, null, null, 20]), "margin-bottom")}
    `,
};

export default typography;
